import {AppBar, Box, Button, Container, styled as styledM, Toolbar,} from "@mui/material";
import {FC, useContext} from "react";
import Logo from "./img/logo_white.png";
import styled from "styled-components";
import PersonIcon from '@mui/icons-material/Person';
import FavoriteIcon from '@mui/icons-material/Favorite';
import {BaseFooter} from "./BaseFooter";
import {useLogin} from "./util/useLogin";
import {ErrorSnackBar} from "./components/error/ErrorSnackBar";
import {AppContext} from "./App";
import {NotificationSnackBar} from "./components/NotificationSnackBar";

const widthThreshold = "720px";

const AsToolBar = styledM(Toolbar)(
  () => `
  min-height: 32px;
  background: #555;
  @media(max-width:${widthThreshold}){
    display: flex;
    justify-content: space-around;
  }
`
);

const ToolBarButton = styledM(Button)(
  () => `
  color:#fff;
  margin: 0 8px;
  @media(max-width:${widthThreshold}){
    margin: 0;
    min-width: 48px;
  }
`
);

const ContentsBox = styledM(Box)(
  () => `
  display:flex;
  flex-flow: column;
  min-height: 100vh;
  `
);
const MainBox = styledM(Box)(
  () => `
  flex: 1;
  `
)

const LogoImg = styled.img`
  max-height: 24px;
`;

const MenuText = styled.span`
  @media (max-width: ${widthThreshold}) {
    display: none;
  }
`;


export const Base: FC = ({children}) => {
  const isLogin = useLogin()
  const {state, dispatch} = useContext(AppContext);

  const closeError = () => {
    dispatch({type: "setError", payload: {error: false, message: ""}});
  };

  const closeNotification = () => {
    dispatch({type: "setNotification"});
  };

  return (
    <ContentsBox>
      {state.error && (
        <ErrorSnackBar errorObj={state.error} onClose={closeError}/>
      )}
      {state.notification && (
        <NotificationSnackBar
          message={state.notification}
          onClose={closeNotification}
        />
      )}
      <AppBar>
        <AsToolBar variant="dense">
          <ToolBarButton href={`/`}>
            <LogoImg src={Logo} alt="ai saloon"/>
          </ToolBarButton>
          <ToolBarButton href={`/pages/login`}>
            <PersonIcon fontSize="small"/>
            {isLogin && <MenuText>マイページ</MenuText>}
            {!isLogin && <MenuText>ログイン</MenuText>}
          </ToolBarButton>
          {isLogin && <ToolBarButton href={`/user_favorite`}>
              <FavoriteIcon fontSize="small"/>
              <MenuText>お気に入り</MenuText>
          </ToolBarButton>}
        </AsToolBar>
      </AppBar>
      <MainBox>
        <AsToolBar variant="dense"/>
        <Box mt={2}>
          <Container maxWidth="md">
            {children}
          </Container>
        </Box>
      </MainBox>
      <BaseFooter/>
    </ContentsBox>
  );
};
